import { useContext } from "react";
import { Navigate, Outlet } from "react-router-dom";
import { AuthContext } from "../contexts/AuthContext";

export function RequireAuth() {
  const { user } = useContext(AuthContext);
  if (!user) return <Navigate to="/login" replace />;
  return <Outlet />;
}

export function RequireAdmin() {
  const { user } = useContext(AuthContext);
  if (!user) return <Navigate to="/admin-login" replace />;
  if (user.role !== "admin" && user.role !== "superadmin")
    return <Navigate to="/" replace />;
  return <Outlet />;
}

export function RequireSuperAdmin() {
  const { user } = useContext(AuthContext);
  if (!user) return <Navigate to="/admin-login" replace />;
  if (user.role !== "superadmin") return <Navigate to="/" replace />;
  return <Outlet />;
}

export function RequireFarmer() {
  const { user } = useContext(AuthContext);
  if (!user) return <Navigate to="/login" replace />;
  if (user.role !== "farmer" && user.role !== "admin" && user.role !== "superadmin")
    return <Navigate to="/" replace />;
  return <Outlet />;
}
